import {
    CREATEPUPOSE,
    GETPURPOSE,
    UPDATEPURPOSE,
    DELETEPURPOSE,
    CREATECOMPLAINT,
    GETCOMPLAINT,
    UPDATECOMPLAINT,
    DELETECOMPLAINT,
    CREATESOURCE,
    GETSOURCE,
    UPDATESOURCE,
    DELETESOURCE,
    CREATEAPPOINTMENTPRIORITY,
    GETAPPOINTMENTPRIORITY,
    UPDATEAPPOINTMENTPRIORITY,
    DELETEAPPOINTMENTPRIORITY,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPUPOSE:
            return {
                ...state,
                purposeSaveStatus: action.payload.success,
            }
        case GETPURPOSE:
                return {
                        ...state,
                        purposeList: action.payload.data,
                        }
        case UPDATEPURPOSE:
                return {
                        ...state,
                        perposeUpdateStatus: action.payload.success,
                        }   

        case DELETEPURPOSE:
                 return {
                     ...state,
                     perposeDeleteStatus: action.payload.success,
                        } 
        case CREATECOMPLAINT:
                return {
                       ...state,
                       complaintSaveStatus: action.payload.success,
            }
        case GETCOMPLAINT:
                return {
                        ...state,
                        complaintList: action.payload.data,
                        }
        case UPDATECOMPLAINT:
                return {
                        ...state,
                        complaintUpdateStatus: action.payload.success,
                        }   

        case DELETECOMPLAINT:
                return {
                     ...state,
                     complintDeleteStatus: action.payload.success,
                        } 
        case CREATESOURCE:
                return {
                        ...state,
                        sourceSaveStatus: action.payload.success,
                        }
        case GETSOURCE:
                return {
                        ...state,
                        sourceList: action.payload.data,
                       }
        case UPDATESOURCE:
                return {
                        ...state,
                        sourceUpdateStatus: action.payload.success,
                       }   
            
        case DELETESOURCE:
                return {
                        ...state,
                        sourceDeleteStatus: action.payload.success,
                      } 
        case CREATEAPPOINTMENTPRIORITY:
                return {
                        ...state,
                        appointmentprioritySaveStatus: action.payload.success,
                        }
        case GETAPPOINTMENTPRIORITY:
                return {
                         ...state,
                        appointmentpriorityList: action.payload.data,
                        }
        case UPDATEAPPOINTMENTPRIORITY:
                return {
                        ...state,
                        appointmentpriorityUpdateStatus: action.payload.success,
                        }   
                    
        case DELETEAPPOINTMENTPRIORITY:
                return {
                        ...state,
                        appointmentpriorityDeleteStatus: action.payload.success,
                       } 
        default:
                return state
            }
         }